import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as invApi from '../../lib/api/inventory';

const [VIEW_INV_TRANINFO, VIEW_INV_TRANINFO_SUCCESS, VIEW_INV_TRANINFO_FAILURE] =
    createRequestActionTypes('inventory/VIEW_INV_TRANINFO');
export const viewInvTranInfo = createAction(VIEW_INV_TRANINFO, (id) => id);
const viewInvTranInfoSaga = createRequestSaga(VIEW_INV_TRANINFO, invApi.getTranInfo);

const UNLOAD_INV_TRANINFO = 'inventory/UNLOAD_INV_TRANINFO';
export const unloadInvTranInfo = createAction(UNLOAD_INV_TRANINFO);

const SET_INV_TRANINFO = 'inventory/SET_INV_TRANINFO';
export const setInvTranInfo = createAction(SET_INV_TRANINFO, (invTranInfo) => invTranInfo);

export function* invTranInfoSaga() {
    yield takeLatest(VIEW_INV_TRANINFO, viewInvTranInfoSaga);
}

const initialState = {
    transInf: null,
    productList: null,
    error: null,
};

const invTranInfo = handleActions(
    {
        [VIEW_INV_TRANINFO_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            transInf: data.list.transInf,
            productList: data.list.productList,
        }),
        [VIEW_INV_TRANINFO_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [UNLOAD_INV_TRANINFO]: () => initialState,
        [SET_INV_TRANINFO]: (state, { payload: data }) => ({
            ...state,
            transInf: data.transInf,
            productList: data.productList,
        }),
    },
    initialState,
);

export default invTranInfo;
